/** @format */

export const dummyWidget = [
  {
    i: '3',
    type: 'event',
    size: 'normal',
    title: 'Hausmessen und Events 2026',
    events: [
      {
        title: 'WM Messe Berlin',
        teaser: 'WM Werkstattmesse\r\n24. - 26.04.2026',
        location: 'Berlin',
        date: 1782284400,
        image: '/sites/default/files/2026-03/wm_small_1.png',
        link: 'https://www.wm-werkstattmessen.de/berlin'
      },
      {
        title: 'WM Messe Dortmund',
        teaser: 'WM Messe Dortmund\r\n04. - 06.09.2026',
        location: 'Dortmund',
        date: 1788505200,
        image: '/sites/default/files/2026-03/wm_small_0.png',
        link: 'https://www.wm-werkstattmessen.de/dortmund'
      },
      {
        title: 'WM Messe München',
        teaser: 'WM Messe München\r\n16. - 18.10.2026',
        location: 'München',
        date: 1792134000,
        image: '/sites/default/files/2026-03/wm_small.png',
        link: 'https://www.wm-werkstattmessen.de/muenchen'
      }
    ]
  },
  {
    i: '2',
    type: 'event',
    size: 'medium',
    title: 'Hausmessen und Events 2026',
    events: [
      {
        title: 'WM Messe Berlin',
        teaser: 'WM Werkstattmesse\r\n24. - 26.04.2026',
        location: 'Berlin',
        date: 1782284400,
        image: '/sites/default/files/2026-03/wm_small_1.png',
        link: 'https://www.wm-werkstattmessen.de/berlin'
      },
      {
        title: 'WM Messe Dortmund',
        teaser: 'WM Messe Dortmund\r\n04. - 06.09.2026',
        location: 'Dortmund',
        date: 1788505200,
        image: '/sites/default/files/2026-03/wm_small_0.png',
        link: 'https://www.wm-werkstattmessen.de/dortmund'
      },
      {
        title: 'WM Messe München',
        teaser: 'WM Messe München\r\n16. - 18.10.2026',
        location: 'München',
        date: 1792134000,
        image: '/sites/default/files/2026-03/wm_small.png',
        link: 'https://www.wm-werkstattmessen.de/muenchen'
      }
    ]
  },
  {
    i: '4',
    type: 'event',
    size: 'large',
    title: 'Hausmessen und Events 2026',
    events: [
      {
        title: 'WM Messe Berlin',
        teaser: 'WM Werkstattmesse\r\n24. - 26.04.2026',
        location: 'Berlin',
        date: 1782284400,
        image: '/sites/default/files/2026-03/wm_small_1.png',
        link: 'https://www.wm-werkstattmessen.de/berlin'
      },
      {
        title: 'WM Messe Dortmund',
        teaser: 'WM Messe Dortmund\r\n04. - 06.09.2026',
        location: 'Dortmund',
        date: 1788505200,
        image: '/sites/default/files/2026-03/wm_small_0.png',
        link: 'https://www.wm-werkstattmessen.de/dortmund'
      },
      {
        title: 'WM Messe München',
        teaser: 'WM Messe München\r\n16. - 18.10.2026',
        location: 'München',
        date: 1792134000,
        image: '/sites/default/files/2026-03/wm_small.png',
        link: 'https://www.wm-werkstattmessen.de/muenchen'
      }
    ]
  },
  {
    i: '5',
    type: 'event',
    size: 'wide',
    title: 'Hausmessen und Events 2026',
    events: [
      {
        title: 'WM Messe Berlin',
        teaser: 'WM Werkstattmesse\r\n24. - 26.04.2026',
        location: 'Berlin',
        date: 1782284400,
        image: '/sites/default/files/2026-03/wm_small_1.png',
        link: 'https://www.wm-werkstattmessen.de/berlin'
      },
      {
        title: 'WM Messe Dortmund',
        teaser: 'WM Messe Dortmund\r\n04. - 06.09.2026',
        location: 'Dortmund',
        date: 1788505200,
        image: '/sites/default/files/2026-03/wm_small_0.png',
        link: 'https://www.wm-werkstattmessen.de/dortmund'
      },
      {
        title: 'WM Messe München',
        teaser: 'WM Messe München\r\n16. - 18.10.2026',
        location: 'München',
        date: 1792134000,
        image: '/sites/default/files/2026-03/wm_small.png',
        link: 'https://www.wm-werkstattmessen.de/muenchen'
      }
    ]
  },
  {
    i: '6',
    type: 'event',
    size: 'xwide',
    title: 'Hausmessen und Events 2026',
    events: [
      {
        title: 'WM Messe Berlin',
        teaser: 'WM Werkstattmesse\r\n24. - 26.04.2026',
        location: 'Berlin',
        date: 1782284400,
        image: '/sites/default/files/2026-03/wm_small_1.png',
        link: 'https://www.wm-werkstattmessen.de/berlin'
      },
      {
        title: 'WM Messe Dortmund',
        teaser: 'WM Messe Dortmund\r\n04. - 06.09.2026',
        location: 'Dortmund',
        date: 1788505200,
        image: '/sites/default/files/2026-03/wm_small_0.png',
        link: 'https://www.wm-werkstattmessen.de/dortmund'
      },
      {
        title: 'WM Messe München',
        teaser: 'WM Messe München\r\n16. - 18.10.2026',
        location: 'München',
        date: 1792134000,
        image: '/sites/default/files/2026-03/wm_small.png',
        link: 'https://www.wm-werkstattmessen.de/muenchen'
      }
    ]
  },
  {
    i: '7',
    type: 'event',
    size: '2xl',
    title: 'Hausmessen und Events 2026',
    events: [
      {
        title: 'WM Messe Berlin',
        teaser: 'WM Werkstattmesse\r\n24. - 26.04.2026',
        location: 'Berlin',
        date: 1782284400,
        image: '/sites/default/files/2026-03/wm_small_1.png',
        link: 'https://www.wm-werkstattmessen.de/berlin'
      },
      {
        title: 'WM Messe Dortmund',
        teaser: 'WM Messe Dortmund\r\n04. - 06.09.2026',
        location: 'Dortmund',
        date: 1788505200,
        image: '/sites/default/files/2026-03/wm_small_0.png',
        link: 'https://www.wm-werkstattmessen.de/dortmund'
      },
      {
        title: 'WM Messe München',
        teaser: 'WM Messe München\r\n16. - 18.10.2026',
        location: 'München',
        date: 1792134000,
        image: '/sites/default/files/2026-03/wm_small.png',
        link: 'https://www.wm-werkstattmessen.de/muenchen'
      },
      {
        title: 'WM Messe Berlin',
        teaser: 'WM Werkstattmesse\r\n24. - 26.04.2026',
        location: 'Berlin',
        date: 1782284400,
        image: '/sites/default/files/2026-03/wm_small_1.png',
        link: 'https://www.wm-werkstattmessen.de/berlin'
      }
    ]
  }
];
